import { ThumbnailFileFragment } from 'types/graphql'

import { AcceptedImages } from 'src/constants'
import { PathPrefixes } from 'src/constants/file'
import { useFileUploadState } from 'src/hooks/use-file-upload-state'

export const MAX_SIGNATURE_WIDTH = 636
const MAX_SIGNATURE_HEIGHT = 200

export const SIGNATURE_ASPECT_RATIO = MAX_SIGNATURE_WIDTH / MAX_SIGNATURE_HEIGHT

export const useSignatureFileUploadState = (args?: {
  afterUpload?: (file: ThumbnailFileFragment) => Promise<void>
}) =>
  useFileUploadState({
    accept: AcceptedImages,
    pathPrefix: PathPrefixes.Signatures,
    afterUpload: args?.afterUpload,
  })
